import axios from 'axios';

const getEnvironment = () => {
  const hostname = window.location.hostname;
  console.log('🌐 [Config] Hostname:', hostname);
  
  if (hostname.includes('staging')) return 'staging';
  if (hostname === 'www.symtomatix.cl' || hostname === 'symtomatix.cl') return 'production';
  if (hostname.includes('vercel.app')) return 'staging';
  return 'development';
};

const ambiente = getEnvironment();
console.log('🔧 [Config] Ambiente:', ambiente);

// Configuración de URLs según ambiente
const API_URLS = {
  development: 'http://localhost:3001/api',
  staging: 'https://triage-staging.up.railway.app/api',
  production: 'https://triage-production.up.railway.app/api'
};

const API_URL = API_URLS[ambiente] || API_URLS.development;
console.log('🌍 [Config] API URL:', API_URL);

const instance = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para agregar el token a las peticiones
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de autenticación
instance.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      // Si el token expiró o es inválido, redirigir al login
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    console.error('Error en la petición:', error);
    return Promise.reject(error);
  }
);

export default instance; 